import * as Blockly from 'blockly/core';
import { stmt } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['break'] = function (block: Blockly.Block): string {
        if (!block.isEnabled()) return '';
        return stmt('break');
    };
}
